import { Routes, Route, Navigate } from 'react-router-dom';
import Overview from './pages/Overview';
import Auction from './pages/Auction';
import Auditing from './pages/Auditing';
import Request from './pages/Request';
import NewRequest from './pages/NewRequest';
import Auditors from './pages/Auditors';
import Governance from './pages/Governance';
import Compliance from './pages/Compliance';
import Account from './pages/Account';
import Toasts from './components/Toasts';

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/auction" element={<Auction />} />
        <Route path="/auditing" element={<Auditing />} />
        <Route path="/request/new" element={<NewRequest />} />
        <Route path="/request/:id" element={<Request />} />
        <Route path="/request" element={<Navigate to="/auditing" replace />} />
        <Route path="/auditors" element={<Auditors />} />
        <Route path="/governance" element={<Governance />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/account" element={<Account />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toasts />
    </>
  );
}
